import Vue from 'vue';
import { Commit } from 'vuex';
import {
    IUserPreferences,
    IPreferencesState,
    DEFAULT_USER_ID,
} from './types';
import {
    createRemoveFromListMutator,
    createToggleListElementMutator,
    createSimpleMutatorAction,
} from './util';
import getters from './getters';

export { PreferencesGetters } from './types';

const REMOVE_TOURNAMENT = 'REMOVE_TOURNAMENT';
const TOGGLE_TOURNAMENT = 'TOGGLE_TOURNAMENT';
const TOGGLE_MARKET = 'TOGGLE_MARKET';
const INITIALIZE_USER_FAVOURITES = 'INITIALIZE_USER_FAVOURITES';
const TOGGLE_EVENT_PIN = 'TOGGLE_EVENT_PIN';
const UNPIN_ALL_EVENTS = 'UNPIN_ALL_EVENTS';

export {
    IPreferencesState
};

const createInitialUserState = (): IUserPreferences => ({
    favouriteTournaments: [],
    favouriteMarkets: [],
    pinnedEvents: [],
});

function defaultState(): IPreferencesState {
    return {
        [DEFAULT_USER_ID]: createInitialUserState(),
    };
}

export default {
    getters,

    namespaced: true,

    state: defaultState(),

    mutations: {
        [REMOVE_TOURNAMENT]: createRemoveFromListMutator('favouriteTournaments'),
        [TOGGLE_TOURNAMENT]: createToggleListElementMutator('favouriteTournaments'),
        [TOGGLE_MARKET]: createToggleListElementMutator('favouriteMarkets'),
        [INITIALIZE_USER_FAVOURITES]: (state: IPreferencesState, userId: string) => {
            Vue.set(state, userId, createInitialUserState());
        },
        [TOGGLE_EVENT_PIN]: createToggleListElementMutator('pinnedEvents'),
        [UNPIN_ALL_EVENTS]: (state: IPreferencesState, { userId } : { userId: string }) => {
            state[userId].pinnedEvents = [];
        },
    },

    actions: {
        initializeUserPreferences: ({ commit, getters, state }:
            {commit: Commit, getters: any, state: IPreferencesState}) => {
            const userId = getters._userId;
            if (!state[userId]) {
                commit(INITIALIZE_USER_FAVOURITES, userId);
            }
        },
        removeTournament: createSimpleMutatorAction(REMOVE_TOURNAMENT),
        toggleTournament: createSimpleMutatorAction(TOGGLE_TOURNAMENT),
        toggleMarket: createSimpleMutatorAction(TOGGLE_MARKET),
        toggleEventPin: createSimpleMutatorAction(TOGGLE_EVENT_PIN),
        unpinAllEvents: createSimpleMutatorAction(UNPIN_ALL_EVENTS),
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/preferences/preferencesIndex.ts